
export interface RentalItem {
  name: string;
  category: string;
  description: string;
}

export enum AppState {
  SEARCHING = 'SEARCHING',
  RESULT = 'RESULT',
  LOADING = 'LOADING',
  EQUIPMENT = 'EQUIPMENT',
  PROJECTS = 'PROJECTS',
  PRIVACY = 'PRIVACY',
  TERMS = 'TERMS',
  SETTINGS = 'SETTINGS',
  ABOUT = 'ABOUT',
  COMPANY = 'COMPANY',
  HOW_IT_WORKS = 'HOW_IT_WORKS'
}
